import gql from "graphql-tag";

export const family = gql`
  query family($userId: String, $childId: String) {
    family(userId: $userId, childId: $childId) {
      child {
        childId
        name
      }
      parents {
        orgRoles {
          org {
            id
            name
          }
          isParent
          isLeader
          isTeacher
          isFundraiser
          fundOrgs
          children {
            childId
            name
            grade
            schoolId
            email
          }
        }
        user {
          id
          name
          mobile
          email
          avatar
          appRate
          userRate
          appRateCount
          userRateCount
          userRateTotal
          state
          accountDisabled
          role
          lastActivity
          sexOffender {
            state
            lastUpdated
          }
          children {
            childId
            name
            grade
            schoolId
            email
            isNew
          }
          orgs {
            id
            name
          }
        }
        profile {
          id
          intro
          interests
          idStatus
          dlStatus
          dlExpirationDate
          note
          noteUpdated
          location {
            addr
          }
        }
        children {
          childId
          name
          email
        }
      }
    }
  }
`;

export const delFamilyChild = gql`
  mutation delFamilyChild($childId: String!) {
    delFamilyChild(childId: $childId)
  }
`;

export const delFamilyship = gql`
  mutation delFamilyship($childId: String!, $userId: String!) {
    delFamilyship(childId: $childId, userId: $userId)
  }
`;

export const saveFamilyChild = gql`
  mutation saveFamilyChild($input: FmChildInput!) {
    saveFamilyChild(input: $input)
  }
`;

const familyAddExistingParent = gql`
  mutation familyAddExistingParent($childIds: [String!]!, $userId: String!) {
    familyAddExistingParent(childIds: $childIds, userId: $userId)
  }
`;

const familyAddNewParent = gql`
  mutation familyAddNewParent($input: FamilyAddNewParentInput!) {
    familyAddNewParent(input: $input)
  }
`;

const familyAddExistingChild = gql`
  mutation familyAddExistingChild($parentIds: [String!]!, $childId: String!) {
    familyAddExistingChild(parentIds: $parentIds, childId: $childId)
  }
`;

const familyAddNewChild = gql`
  mutation familyAddNewChild($input: FamilyAddNewChildInput!) {
    familyAddNewChild(input: $input)
  }
`;

export const changeChildrenSchool = gql`
  mutation changeChildrenSchool($input: ChangeChildrenSchoolInput!) {
    changeChildrenSchool(input: $input)
  }
`;

export const updateChild = gql`
  mutation updateChild($input: UpdateChildInput!) {
    updateChild(input: $input)
  }
`;

export const updateUserNote = gql`
  mutation updateUserNote($userId: String!, $note: String!) {
    updateUserNote(userId: $userId, note: $note)
  }
`;

export const updateUserRoles = gql`
  mutation updateUserRoles($userId: String!, $roles: [String!]!) {
    updateUserRoles(userId: $userId, roles: $roles)
  }
`;

export const updateUserSexOffender = gql`
  mutation updateUserSexOffender($userId: String!, $state: String!) {
    updateUserSexOffender(userId: $userId, state: $state) {
      sexOffender {
        state
        lastUpdated
      }
      accountDisabled
    }
  }
`;

export const enableUserAccount = gql`
  mutation enableUserAccount($userId: String!, $reason: String!) {
    enableUserAccount(userId: $userId, reason: $reason)
  }
`;
export const disableUserAccount = gql`
  mutation disableUserAccount($userId: String!, $reason: String!) {
    disableUserAccount(userId: $userId, reason: $reason)
  }
`;

export const familyGql = {
  family,
  changeChildrenSchool,
  familyAddExistingParent,
  familyAddNewParent,
  familyAddExistingChild,
  familyAddNewChild,
  delFamilyChild,
  delFamilyship,
  saveFamilyChild,
  updateChild,
  updateUserNote,
  updateUserSexOffender,
  enableUserAccount,
  disableUserAccount,
  updateUserRoles,
};
